import {
  PlaygroundComponentMessages,
  PlaygroundRunMessage,
  PlaygroundRunResult,
  PlaygroundSeedMessage,
} from "../types";

// The Run payload takes the plain public message shapes. Delete
// superfluous fields that may have been provided by the seed.
export const toRunMessage = (
  message: PlaygroundSeedMessage
): PlaygroundRunMessage => {
  const stripped: Record<string, unknown> = { ...message };
  delete stripped.source;
  delete stripped.origin_session_id;
  delete stripped.origin_moment_id;
  return stripped as PlaygroundRunMessage;
};

// The run payload's seed: each component's messages, in the plain shapes.
export const toRunComponentMessages = (
  componentMessages: PlaygroundComponentMessages
): Record<string, Array<PlaygroundRunMessage>> =>
  Object.fromEntries(
    Object.entries(componentMessages).map(([componentId, messages]) => [
      componentId,
      messages.map(toRunMessage),
    ])
  );

// Client-side batches: how many run requests may be outstanding at once,
// and how large a batch the count field accepts.
export const MAX_CONCURRENT_RUNS = 5;
export const MAX_BATCH_RUNS = 50;

// The batch size the count field names — a whole number within the batch
// budget — or null when it isn't one.
export const parseBatchCount = (value: string): number | null => {
  const count = Number(value);
  return Number.isInteger(count) && count >= 1 && count <= MAX_BATCH_RUNS
    ? count
    : null;
};

// One entry in the Runner's results list. Records are appended as
// "running" and settle to "ok"/"error"; they live with the draft and are
// dropped when a different source is loaded.
export type PlaygroundRunRecord = {
  id: number;
  startedAt: number;
  cue: string | null;
  // The org service the config's agent_llm named when the run started, and
  // the params its entry carried.
  agentLlm: string | null;
  agentLlmParams: Record<string, unknown>;
  status: "running" | "ok" | "error";
  result?: PlaygroundRunResult;
  error?: string;
};
